import MentionsOfficialAccountCommentRoute from './MentionsOfficialAccountCommentRoute';

export default MentionsOfficialAccountCommentRoute;
